<div class="p-3 bg-white" [formGroup]="userForm" style="min-width: 450px; font-size: 0.88rem;">
  
  <div class="border-bottom pb-2 mb-3">
    <h3 class="h5 m-0 fw-bold text-dark">🔑 Gestión de Seguridad y Roles JDE</h3>
    <span class="small text-muted font-monospace">User Profile Master Control</span>
  </div>

  <!-- Identificadores fijos -->
  <div class="row g-2 mb-3">
    <div class="col-md-6">
      <div class="form-floating">
        <input type="text" class="form-control bg-light font-monospace fw-bold text-primary" id="userId" formControlName="userId">
        <label for="userId">Login User ID</label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating">
        <input type="number" class="form-control" id="an8" formControlName="an8">
        <label for="an8">Libro de Direcciones AN8 *</label>
      </div>
    </div>
  </div>

  <!-- Switch de estatus de cuenta -->
  <div class="form-check form-switch mb-3">
    <input class="form-check-input" type="checkbox" id="enabledSwitch" formControlName="enabled">
    <label class="form-check-label fw-bold" for="enabledSwitch">Cuenta de Empleado Activa y Habilitada</label>
  </div>

  <!-- Nueva clave opcional -->
  <div class="form-floating mb-3">
    <input type="password" class="form-control" id="password" formControlName="password" placeholder="Clave">
    <label for="password">Restablecer Contraseña (Dejar vacío para conservar actual)</label>
  </div>

  <!-- 🛡️ MATRIZ SELECCIÓN DE ROLES POR UDC (SINTAXIS PURA CORREGIDA) -->
  <div class="card bg-light border-0 p-2 mb-3">
    <label class="fw-bold text-secondary mb-2 small text-uppercase">Matriz de Privilegios Autorizados (UDC)</label>
    
    <div formArrayName="rolesSeleccionados">
      <!-- 🚀 CORREGIDO: Eliminada la frase 'let rol' que causaba el quiebre de tokens -->
      <div *ngFor="let ctrl of rolesControls; let i = index" class="form-check mb-1">
        <input class="form-check-input" type="checkbox" [formControlName]="i" [id]="'rol_' + i">
        <label class="form-check-label fw-semibold" [for]="'rol_' + i">
          💼 {{ catRolesUdc[i]?.description }} <span class="badge bg-dark font-monospace text-xs">{{ catRolesUdc[i]?.strValue1 }}</span>
        </label>
      </div>
    </div>
  </div>

  <!-- Botonera inferior -->
  <div class="d-flex justify-content-end gap-2 border-top pt-2">
    <button type="button" class="btn btn-sm btn-light border" (click)="dialogRef.close()">Cancelar</button>
    <button type="button" class="btn btn-sm btn-primary px-4 fw-bold shadow-sm" (click)="onSave()">💾 Aplicar Permisos Atómicos</button>
  </div>
</div>